/*-------- Date Selection --------*/
function convertToObject(arr) {
  var rv = {};
  for (var i = 0; i < arr.length; ++i) rv[i] = arr[i];
  return rv;
}

/*
function getAvailableDates(data_sku, data_variant) {
  let headers = new Headers();  
  headers.append('Content-Type', 'application/json');
  headers.append('Accept', 'application/json');
  headers.append('Access-Control-Allow-Credentials', 'true');
  headers.append('crossDomain', 'true');
  
  var fetchRes = fetch('https://api.meyerhatchery.com:89/mpc-chickavail.a5w?pword=dsasaki053');
  fetchRes.then(response => response.text())
  .then(data => {
    
      const result = data.split(/\r?\n/);
      var productData = { availableDates: [] };      
      for (let i = 0; i < result.length; i++) {
          var array2 = result[i].split(",");
          const jsonStrings = array2.map(item => JSON.stringify(item))
          const jsonParse = jsonStrings.map((s) => JSON.parse(s))
          productData.availableDates.push(convertToObject(jsonParse));
      }
      //console.log(productData); 

      if (window.location.pathname.indexOf('/cart') !== -1) {
        // Single Json for All Variant in Search Result 
        var searchResFirst = [];
        var searchResCart = [];      
        var searchFieldCart = productData.availableDates;
        var searchSkuCart = data_sku;
        var searchVarCart = data_variant;
        console.log("data_sku", data_sku); 
        //console.log("data_variant", searchVarCart); 
      
        for (var i=0; i<searchFieldCart.length; i++) {
          //for (let j = 0; j < searchSkuCart.length; j++) { 
            var straight = searchFieldCart[i][3];
            var female = searchFieldCart[i][4];
            var male = searchFieldCart[i][5]; 
            
            //const sameCaseArray = searchSkuCart.map(value => value.toLowerCase());          
            // if(searchSkuCart.includes(searchFieldCart[i][1])){  
            //   console.log(searchFieldCart[i][1],"-->", "-----",searchFieldCart[i][2], "-----", straight, "-----", female, "-----", male);
            // }
            
            if(searchSkuCart.includes(searchFieldCart[i][1])){                
              //console.log("all", searchFieldCart[i]);
              
              var sName = searchFieldCart[i][1];
              var vName = searchVarCart[i];
              if (!searchResFirst[sName]){
                searchResFirst[sName] = [];
              }
              
              searchResFirst[sName].push(searchFieldCart[i]);           
            }
          //}
        }
        console.log("searchResFirst", searchResFirst);
      
        let newSearchResFirst = [];
        Object.keys(searchResFirst).map((x) => {
          searchResFirst[x].map((y) => {
            newSearchResFirst.push(y)
          })
        })
        
        const uniq = newSearchResFirst
        .map((name) => {
          return {
            count: 1,
            name: name["2"]
          };
        })
        .reduce((result, b) => {
          result[b.name] = (result[b.name] || 0) + b.count;
      
          return result;
        }, {});
        const newSearchResDuplicates = Object.keys(uniq).filter((a) => uniq[a] >= searchSkuCart.length);
               
        //console.log("newSearchResDuplicates", newSearchResDuplicates);
        
       //------ Cart Page ------
          //---- Check Date available in all items ----
          function checkEmptyDates() {
            for (let j = 0; j < searchSkuCart.length; j++) {
              all_items.forEach(function(cartItem) {                  
                var itemDetails = cartItem.querySelector('.item_variant_sku');          
                if(itemDetails != null) {    
                  var itemSKU = itemDetails.getAttribute('data-sku');                    
                  if(searchSkuCart[j] == itemSKU) {
                    var itemClass = "."+searchSkuCart[j]; 
                    var groupField = document.querySelector(itemClass).querySelector(".shipdate_select"); 
                    var groupErr = document.querySelector(itemClass).querySelector(".date_error_msg");                     
                    groupField.dataset.checkdate = "is_empty";
                    
                    groupErr.innerHTML = "There are no available shipping dates for the selected breeds. Please adjust the selected breeds and try again.";          
                    groupErr.style.display = "block";
                    console.log("AD shippingDate_option");
                    //setTimeout(() => { groupErr.style.display = "none"; }, 5000);
                    //console.log("groupField-->", groupField);
                  }            
                }                                          
              });
            }
            
            document.querySelectorAll(".cartitems").forEach(function(spiner){
              if(spiner.querySelector('.blog-loader') != null){
                spiner.querySelector('.blog-loader').style.display = "none";
              }
            });
          } 
        
        if(newSearchResDuplicates.length == 0) {
          
          //---- If Same date not Found ------                 
          setTimeout(function() { 
            checkEmptyDates()            
          }, 500);                    
          //console.log("If - newSearchResDuplicates", newSearchResDuplicates);
          
        }else{
          console.log("Else - newSearchResDuplicates", newSearchResDuplicates);
          
          shipdate_html = "";   
          optionCount = 0;
          var Last_loop = newSearchResDuplicates.length -1;    
          newSearchResDuplicates.forEach(function(e,i){            
            if(optionCount == 0){              
              shipdate_html += '<option value="">Select Shipping Date</option><option value="'+ newSearchResDuplicates[i] +'">' + newSearchResDuplicates[i] + '</option>';
            }else{              
              shipdate_html += '<option value="'+ newSearchResDuplicates[i] +'">' + newSearchResDuplicates[i] + '</option>';
            }            
            optionCount += 1;
            for (let j = 0; j < searchSkuCart.length; j++) {
              var all_items = document.querySelectorAll('.cartitems');   
              var itemClass = "."+searchSkuCart[j];              
              var AppendElement = document.querySelector(itemClass).querySelector(".shipdate_select");
              AppendElement.innerHTML = shipdate_html;                    
            }
            if(Last_loop == i){
              setTimeout(function() { 

                all_items.forEach(function(cartItem) {                         
                  var itemHidenDate = cartItem.querySelector('.shipDate_forAll');                    
                  var itemDropdown =  cartItem.querySelector(".shipdate_select");
                  
                  if(itemDropdown != null ) { 
                      if(itemHidenDate != null ) {                         
                        var grpHName = itemHidenDate.dataset.group;
                        var grpHDate = itemHidenDate.value;
                        //console.log("itemHidenDate grpHName", grpHName, "itemHidenDate grpHDate", grpHDate);
                      }                      
                      
                      var grpDName = itemDropdown.dataset.group;                      
                      if(grpHName == grpDName){                                                                            
                        itemDropdown.value = grpHDate;                        
                      }
                    
                  }                                          
                });                
                                                            
                document.querySelectorAll(".cartitems").forEach(function(spiner){
                  if(spiner.querySelector('.blog-loader') != null){
                    spiner.querySelector('.blog-loader').style.display = "none";
                  }
                });
                
              }, 500);
              
            }
          });
        }
                
      }
                  
  })
  .catch((error) => {
    console.error('Error:', error);
        
    // setTimeout(function() {
    //   if(document.querySelector('.blog-loader') != null){ document.querySelector('.blog-loader').style.display = 'none';  }
    // }, 500);
        
  });
}
*/

/*------- NEW API -----*/

function getAvailableDates(data_sku, data_variant) {
  var dataToPost = { sku: data_sku };
  /* fetch('https://app.mypetchicken.com/product-sync/api/product', { */
  /*fetch("https://apps.mypetchicken.com/product-sync/api/product", {*/
  /*fetch('https://modest-wright.38-132-102-30.plesk.page/api/product', { //added by Ben in 2024-09-10*/
  fetch('https://ancona.mypetchicken.com/api/product', { //added by Ben in 2024-09-16
    method: "POST",
    body: JSON.stringify(dataToPost),
    mode: "cors",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
  })
    .then((response) => response.json())
    .then((results) => {
      //const resultData = results.data;

      if (window.location.pathname.indexOf("/cart") !== -1) {
        // Single Json for All Variant in Search Result
        var searchResFirst = [];
        var searchResCart = [];
        var searchFieldCart = results.data;
        var searchSkuCart = data_sku;
        var searchVarCart = data_variant;
        console.log("data_sku", data_sku, typeof data_sku);
        console.log("data_variant", searchVarCart);
        console.log('Response', searchFieldCart);

        for (var i = 0; i < searchFieldCart.length; i++) {
          for (var key in data_sku) {
            if (data_sku.hasOwnProperty(key)) {
              if (data_sku[key] == searchFieldCart[i]["sku"]) {
                const chk_qty_items = document.querySelectorAll(".cartitems");
                var chk_qty_itemClass =
                  "." +
                  searchSkuCart[key].trim().toLowerCase().replaceAll(" ", "-");
                var selected_item_date = document
                  .querySelector(chk_qty_itemClass)
                  .querySelector(".shipDate_forAll").value;
                var selected_item_qty = document
                  .querySelector(chk_qty_itemClass)
                  .querySelector(".quantity_input");
                var min_qty_err_val = document
                  .querySelector(chk_qty_itemClass)
                  .querySelector(".minimum_qty_err");

                if (
                  selected_item_date == searchFieldCart[i]["date"] &&
                  selected_item_qty.value > searchFieldCart[i]["qty"]
                ) {
                  if (min_qty_err_val != null) {
                    min_qty_err_val.innerHTML =
                      "Qty is greater than inventory.";
                    min_qty_err_val.style.display = "block";
                    if (min_qty_err_val.classList.contains("hidden")) {
                      min_qty_err_val.classList.remove("hidden");
                    }

                    selected_item_qty.dataset.qtyGreaterInventory = "Yes";
                  } else {
                    selected_item_qty.dataset.qtyGreaterInventory = "No";
                  }
                  //console.log("matched -> ", data_sku[key],searchFieldCart[i]['date'] , searchFieldCart[i]['qty'], selected_item_date);
                }
              }
            }
          }

          if (
            searchSkuCart.includes(searchFieldCart[i]["sku"]) &&
            searchFieldCart[i]["qty"] > 0
          ) {
            /*console.log("all", searchFieldCart[i]);*/

            var sName = searchFieldCart[i]["sku"];
            var vName = searchVarCart[i];
            if (!searchResFirst[sName]) {
              searchResFirst[sName] = [];
            }

            searchResFirst[sName].push(searchFieldCart[i]);
          }
        }
        //console.log("searchResFirst", searchResFirst);

        let newSearchResFirst = [];
        Object.keys(searchResFirst).map((x) => {
          searchResFirst[x].map((y) => {
            newSearchResFirst.push(y);
          });
        });

        const uniq = newSearchResFirst
          .map((date) => {
            return {
              count: 1,
              date: date["date"],
            };
          })
          .reduce((result, b) => {
            result[b.date] = (result[b.date] || 0) + b.count;

            return result;
          }, {});
        const newSearchResDuplicates = Object.keys(uniq).filter(
          (a) => uniq[a] >= searchSkuCart.length
        );

        /*console.log("============newSearchResFirst===============", newSearchResFirst)
        console.log("============newSearchResDuplicates===============", newSearchResDuplicates) */
        //console.log("newSearchResDuplicates", newSearchResDuplicates);

        /*------ Cart Page ------*/
        /*---- Check Date available in all items ----*/
        function checkEmptyDates() {
          for (let j = 0; j < searchSkuCart.length; j++) {
            all_items.forEach(function (cartItem) {
              var itemDetails = cartItem.querySelector(".item_variant_sku");
              if (itemDetails != null) {
                var itemSKU = itemDetails.getAttribute("data-sku");
                console.log(
                  "searchSkuCart[j]",
                  searchSkuCart[j].trim().replaceAll(" ", "-")
                );
                if (searchSkuCart[j] == itemSKU) {
                  var itemClass =
                    "." +
                    searchSkuCart[j].trim().toLowerCase().replaceAll(" ", "-");
                  var groupField = document
                    .querySelector(itemClass)
                    .querySelector(".shipdate_select");
                  var groupErr = document
                    .querySelector(itemClass)
                    .querySelector(".date_error_msg");
                  groupField.dataset.checkdate = "is_empty";

                  groupErr.innerHTML =
                    "Select a ship date from the drop-down menu above. If no dates appear when clicked, there are no mutually available dates for your selected breeds and quantities. Please adjust your selections or contact us for help.";
                  groupErr.style.display = "block";
                  //console.log("AD shippingDate_option");
                }
              }
            });
          }

          document.querySelectorAll(".cartitems").forEach(function (spiner) {
            if (spiner.querySelector(".blog-loader") != null) {
              spiner.querySelector(".blog-loader").style.display = "none";
            }
          });

          if (typeof enableDuplicateCheckout === 'function') {
            enableDuplicateCheckout();
          }
        }


        if (newSearchResDuplicates.length == 0) {
          /*---- If Same date not Found ------*/
          setTimeout(function () {
            checkEmptyDates();
          }, 500);
          //console.log("If New - newSearchResDuplicates", newSearchResDuplicates);
        } else {
          //console.log("Else New - newSearchResDuplicates", newSearchResDuplicates);

          shipdate_html = "";
          optionCount = 0;
          var Last_loop = newSearchResDuplicates.length - 1;
          newSearchResDuplicates.forEach(function (e, i) {
            if (optionCount == 0) {
              shipdate_html +=
                '<option disabled selected value="">Select Shipping Date</option><option value="' +
                newSearchResDuplicates[i] +
                '">' +
                newSearchResDuplicates[i] +
                "</option>";
            } else {
              shipdate_html +=
                '<option value="' +
                newSearchResDuplicates[i] +
                '">' +
                newSearchResDuplicates[i] +
                "</option>";
            }
            optionCount += 1;
            for (let j = 0; j < searchSkuCart.length; j++) {
              var all_items = document.querySelectorAll(".cartitems");
              console.log(
                "Checksku->",
                searchSkuCart[j].trim().toLowerCase().replaceAll(" ", "-")
              );
              var itemClass =
                "." +
                searchSkuCart[j].trim().toLowerCase().replaceAll(" ", "-");
              var AppendElement = document
                .querySelector(itemClass)
                .querySelector(".shipdate_select");
              AppendElement.innerHTML = shipdate_html;
            }
            if (Last_loop == i) {
              setTimeout(function () {
                all_items.forEach(function (cartItem) {
                  var itemHidenDate =
                    cartItem.querySelector(".shipDate_forAll");
                  var itemDropdown = cartItem.querySelector(".shipdate_select");

                  var itemQty_gt_invt = cartItem
                    .querySelector(".quantity_input")
                    .getAttribute("data-qty-greater-inventory");

                  /*---- Check Qty greater inventory and Set Error -----*/
                  //console.log(itemQty_gt_invt, 'itemQty_gt_invt');
                  if (itemQty_gt_invt == "Yes") {
                    /*console.log(Qty_gt_invt_err, 'inn');*/
                    Qty_gt_invt_err = true;
                    cartItem.querySelector(".minimum_qty_err").innerHTML =
                      "Qty is greater than inventory.";
                  }

                  if (itemDropdown != null) {
                    if (itemHidenDate != null) {
                      var grpHName = itemHidenDate.dataset.group;
                      var grpHDate = itemHidenDate.value;
                      //console.log("itemHidenDate grpHName", grpHName, "itemHidenDate grpHDate", grpHDate);
                    }

                    var grpDName = itemDropdown.dataset.group;
                    if (grpHName == grpDName) {
                      itemDropdown.value = grpHDate;
                    }
                  }
                });

                document
                  .querySelectorAll(".cartitems")
                  .forEach(function (spiner) {
                    if (spiner.querySelector(".blog-loader") != null) {
                      spiner.querySelector(".blog-loader").style.display =
                        "none";
                    }
                  });

                if (Qty_gt_invt_err && typeof enableDuplicateCheckout === 'function') {
                  enableDuplicateCheckout();
                }
              }, 500);

            }
          });
        }
      }
    })
    .catch((error) => {
      console.error("Error:", error);

      /*
    setTimeout(function() {
      if(document.querySelector('.blog-loader') != null){ document.querySelector('.blog-loader').style.display = 'none';  }
    }, 500);
    */
    });
}
